export default __webpack_public_path__ + "static/media/3.8765734a.png";